import { Button, Space } from 'antd';

interface ActionButtonsProps {
  selectedKeys: string[];
  onBatchAlert: () => void;
  onBatchDeAlert: () => void;
  onBatchFrozen: () => void;
  onBatchUnFrozen: () => void;
  onBatchBan: () => void;
  onBatchUnforbidden: () => void;
  onBatchUpdateUserType: () => void;
  onBatchLimitOpen: () => void;
  onBatchLimitClose: () => void;
}

const ActionButtons = ({
  selectedKeys,
  onBatchAlert,
  onBatchDeAlert,
  onBatchFrozen,
  onBatchUnFrozen,
  onBatchBan,
  onBatchUnforbidden,
  onBatchUpdateUserType,
  onBatchLimitOpen,
  onBatchLimitClose
}: ActionButtonsProps) => {
  return (
    <div className="actions-container">
      <Space size="small" wrap>
        <Button
          type="primary"
          danger
          disabled={selectedKeys.length === 0}
          onClick={onBatchLimitOpen}
        >
          批量限额开启
        </Button>
        <Button
          type="primary"
          disabled={selectedKeys.length === 0}
          onClick={onBatchLimitClose}
        >
          批量限额关闭
        </Button>
        <Button
          type="primary"
          danger
          disabled={selectedKeys.length === 0}
          onClick={onBatchAlert}
        >
          批量警告
        </Button>
        <Button
          type="primary"
          disabled={selectedKeys.length === 0}
          onClick={onBatchDeAlert}
        >
          批量解除警告
        </Button>
        <Button
          type="primary"
          danger
          disabled={selectedKeys.length === 0}
          onClick={onBatchFrozen}
        >
          批量冻结
        </Button>
        <Button
          type="primary"
          disabled={selectedKeys.length === 0}
          onClick={onBatchUnFrozen}
        >
          批量解除冻结
        </Button>
        <Button
          type="primary"
          danger
          onClick={onBatchBan}
          disabled={selectedKeys.length === 0}
        >
          批量封禁
        </Button>
        <Button
          type="primary"
          disabled={selectedKeys.length === 0}
          onClick={onBatchUnforbidden}
        >
          批量解封
        </Button>
        <Button
          type="primary"
          disabled={selectedKeys.length === 0}
          onClick={onBatchUpdateUserType}
        >
          批量打标
        </Button>
      </Space>
    </div>
  );
};

export default ActionButtons;
